/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CacheMetric } from '../models/CacheMetric';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MetricsService {
    /**
     * Get Daily Cache Metrics
     * @param start
     * @param stop
     * @returns CacheMetric Successful Response
     * @throws ApiError
     */
    public static getDailyCacheMetricsMetricsCacheGet(
        start: string,
        stop: string,
    ): CancelablePromise<Array<CacheMetric>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/metrics/cache',
            query: {
                'start': start,
                'stop': stop,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
